import { graphql } from "@opensea/graphql"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"

export const ItemPreviewTooltipTraitTableRowFragment = graphql(
  `
    fragment ItemPreviewTooltipTraitTableRow on ItemAttributeType {
      value
      traitType
      floorPrice {
        native {
          unit
        }
        ...TokenPrice
      }
    }
  `,
  [TokenPriceFragment],
)

export const ItemPreviewTooltipTraitTableFragment = graphql(
  `
    fragment ItemPreviewTooltipTraitTable on Item {
      attributes {
        ...ItemPreviewTooltipTraitTableRow
      }
    }
  `,
  [ItemPreviewTooltipTraitTableRowFragment],
)
